<template>
    <!-- 二级页导航 -->
    <div class="header-container full-screen-container header-shadow">
        <div class="main-container flex-between">
            <div class="left-wrap flex-start">
                <div class="flex-start pointer" ref="logoInfoRef" @click="goPage('home')">
                    <img class="logo" :src="brandInfo?.otherNavLogoUrl || config.defaultLogo" alt="logo">
                    <div class="site-name" :title="brandInfo?.siteName">
                        <span v-for="(item, index) in siteNameArr" :key="index">{{ item }}</span>
                    </div>
                </div>
                <div class="menu-container" ref="mainMenuRef">
                    <ul class="menu-list flex-start" v-show="navList?.length">
                        <li
                            v-for="menuItem in (navList || [])"
                            class="menu-item flex-start"
                            :class="['pointer', {'active': activeId && activeId === menuItem.id }, {'mar-r40': menuItem?.sub_navs?.length}]"
                            :key="menuItem?.id"
                            :title="menuItem?.title"
                            @click="changeMenu(menuItem)"
                            >
                            <div class="menu-item-name" :title="menuItem?.title" :class="[{'menu-item-snv': menuItem?.sub_navs?.length }]">{{menuItem?.title}}</div>
                            <ul
                                class="submenu-list pop-menu-list" v-if="menuItem?.sub_navs?.length">
                                <li
                                    class="pop-menu-item"
                                    v-for="subItem in (menuItem?.sub_navs || [])"
                                    :key="subItem?.id"
                                    @click.stop="changeMenu(subItem)">
                                    {{subItem?.title}}
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
                <!-- 更多导航 -->
                <div v-show="menuList?.length > 6" class="option-wrap" @mouseenter="changeWidth">
                    <span class="option-wrap-more">更多</span> 
                    <div class="more-menu-list" ref="menuRef"   :style="menuWidth">
                        <div
                            v-for="(item, index) in moreNavList"
                            :key="index"
                            class="mar-l40">
                            <div
                                class="pop-menu-header"
                                :class="{ 'pointer title-hover': !item.sub_navs || item.sub_navs.length === 0 }"
                                @click="changeMenu(item, -1)">
                                {{item.title}}
                            </div>
                            <ul v-if="item?.sub_navs?.length">
                                <li
                                    class="more-menu-item"
                                    v-for="(childrenItem, index) in item.sub_navs"
                                    :key="index"
                                    @click.stop="changeMenu(childrenItem, -1)">
                                    {{childrenItem.title}}
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <!-- 工具导航 -->
                <div class="tools-wrap" v-if="toolNavList?.length && toolNavList[0]?.sub_navs">
                    <div  class="tools-title" v-if="toolNavList[0]?.custom_name">{{toolNavList[0].custom_name}}</div>
                    <span v-else class="iconfont icon-a-fenlei2"></span>
                    <ul
                        class="submenu-list pop-menu-list">
                        <li
                            class="pop-menu-item"
                            v-for="subItem in (toolNavList[0]?.sub_navs || [])"
                            :key="subItem?.id"
                            @click="changeMenu(subItem)">
                            {{subItem?.title}}
                        </li>
                    </ul>
                </div>
            </div>
            <div class="right-wrap">
                
                <!-- 搜索内容 -->
                <!-- <el-input
                    ref="headerInputRef"
                    v-if="isSearch"
                    v-model.trim="searchVal"
                    placeholder="请输入搜索内容"
                    class="search-wrap">
                    <template #suffix>
                        <i class="iconfont icon-sousuo suffix-icon" />
                    </template>
                </el-input>
                <span v-else ref="headerSearchRef" class="search-wrap-icon" @click="isSearch = !isSearch">
                    <i class="iconfont icon-sousuo suffix-icon" />
                </span> -->
                <!-- <el-divider class="middle-divider" direction="vertical"></el-divider> -->
                <template v-if="currentUser?.userId">
                    <!-- <div class="news-img-wrap pointer">
                       <img class="news-img" src="~@/assets/img/gateway/news@2x.png" alt="">
                    </div> -->
                    <div class="news-img-wrap pointer" @click="goPage('myMessage')">
                        <span class="iconfont icon-xiaoxi"></span>
                        <span v-if="unreadMessageNum" class="news-num">{{unreadMessageNum > 99 ? '99+' : unreadMessageNum}}</span>
                    </div>
                    <HeaderDrop :applications="applications"></HeaderDrop>
                </template> 
                 <!-- 去登录 -->
                <template v-else>
                    <span class="login-btn pointer" @click="goLogin">{{isRegist ? '登录/注册': '登录'}}</span>
                </template>
            </div>
        </div>
    </div>
</template>
   
<script setup>
import { ref, computed, watch, onBeforeUnmount, onMounted, inject } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { pageJump } from '@/global/location-transfer';
import { getUrl } from '@/router/jumpHref.js';
import config from '@/global/config'
import { staticRoutes } from '@/router';
import HeaderDrop from '@/components/menu/part/header-drop';

const moocComName = inject('moocComName');

const store = useStore();
const route = useRoute();

const emit = defineEmits(['change-menu'])

const props = defineProps({
    menuList: { // 菜单
        type: Array,
        default: () => {
            return [];
        }
    },
    activeRoute: {
        type: Object,
        default: () => {
            return {};
        }
    }
})

const registMap = computed(() => {
    let pagePermission = store.state?.pagePermission || {};
    let list = pagePermission['accountManage:loginAndRegist:isOpen']?.moduleRuleList || [];
    let temp = {};
    list?.length && list.forEach(element => {
        temp[element.ruleKey] = element.checked;
    });
    return temp;
})

const isRegist = computed(() => {
    return !registMap.value?.['0'];
})



// 获取当前用户信息
const currentUser = ref({});
const username = computed(() => {
    return currentUser.value?.realName || currentUser.value?.name || ''
})

// 监听个人信息变化
watch(() => store.state.currentUser, (val) => {
    currentUser.value = val;
    if(val.userId) {
        store.dispatch('user/getUnreadMessage')
        getApplicationList()
    }
}, {deep: true, immediate: true});

const unreadMessageNum = computed(() => {
    let likeNum = store.state?.unreadMessage?.like || 0;
    let msgNum = store.state?.unreadMessage?.message || 0;
    return likeNum + msgNum
})

// 搜索内容
const searchVal = ref('');

// 是否展开search
const isSearch = ref(false);

// 全部备案信息
const brand = computed(() => {
    // console.log('brand====', JSON.stringify(store.state.brand))
    return store.state.brand?.publishBrand || {};
})

// 具体备案信息
const brandInfo = computed(() => {
    // console.log('brandInfo====', JSON.stringify(brand.value?.brandConfig))
    return brand.value?.brandConfig || {};
})

const siteNameArr = computed(() => {
    let nameArr = [];
    let name = brandInfo.value?.siteNameFormat || brandInfo.value?.siteName || '';
    if(name) {
        let arr = name.split('\n') || [];
        let len = 0;
        arr.map((item) => {
            if(len + item.length > 14) {
                let syLen = 14 - len;
                nameArr.push(item.slice(0, syLen));
            }else {
                len += item.length;
                nameArr.push(item);
            }
        })
    }
    return nameArr;
});

// 当前选中的导航
const activeId = computed(() => {
    return props.activeRoute?.id || '';
})

// 前五个导航
const navList = computed(() => {
    let menuList = props.menuList?.length ? props.menuList : [];
    menuList = menuList.filter(item => item.moduleKey !== 'toolkit');
    // return menuList?.length && menuList.slice(0, 6) || []
    return calculateNavCount(menuList);
    
})

// 更多导航
const moreNavList = computed(() => {
    let menuList = props.menuList?.length ? props.menuList : [];
    menuList = menuList.filter(item => item.moduleKey !== 'toolkit');
    return menuList?.length && menuList || []
})

// 工具导航
const toolNavList = computed(() => {
    let menuList = props.menuList?.length ? props.menuList : [];
    menuList = menuList.filter(item => item.moduleKey === 'toolkit');
    return menuList?.length && menuList || [];
})

const itemMarginLeft = ref(40);
const menuContainerMaxWidth = ref(650);
let showMore = ref(false)

function calculateNavCount(menuList){
    if(!menuList || menuList.length == 0){
        return [];
    }
    let totalWidth = 0;
    for (let index = 0; index < menuList.length; index++) {
        let element = menuList[index];
        let itemWidth = getItemTitleLength(element.title || '') + itemMarginLeft.value;
        totalWidth += itemWidth;
        if(totalWidth >= menuContainerMaxWidth.value){
            showMore.value = (index-1) < menuList.length - 1
            return menuList.slice(0, index);
        }
    }
    return menuList;
    
}

const menuRef = ref(null);

const logoInfoRef = ref(null);

const mainMenuRef = ref(null);

const menuWidth = ref({});
const moreMenuListPosition = ref({});

function changeWidth() {
    let logoW = logoInfoRef.value?.clientWidth || 0;
    let menuW = mainMenuRef.value?.clientWidth || 0;
    let navW = logoW + menuW + 50 + 42;
    if (menuRef.value?.clientWidth > navW ) {
        menuWidth.value = {
            width: `${navW}px`,
            justifyContent: 'flex-end',
            flexWrap: 'wrap',
        };
    }
    // if(getTitleTotalLength()>30){ // title长度太长，会导致下拉显示view过于靠左，所以，右移一下
    //     menuWidth.value ={
    //         right: '-200px',
    //     }
    // }

    if(getTitleTotalLength()>40 && getTitleTotalLength()<=60){ // title长度太长，会导致下拉显示view过于靠左，所以，右移一下
        moreMenuListPosition.value ={
            right: '-200px',
        }
    }else if(getTitleTotalLength()>60){
        moreMenuListPosition.value ={
            right: '-300px', 
        }
    }else{
        moreMenuListPosition.value ={
            right: '0px',
        }
    }
}

function getTitleTotalLength(){
    let length =0;
    let menuList = props.menuList?.length ? props.menuList : [];
    menuList = menuList.filter(item => item.moduleKey !== 'toolkit');
    menuList.forEach((item) => {
        length += item.title?.length || 0;
    })
    return length;
}

// 
function getItemTitleLength(str) {
    return getTxtWidth(str, 14);
}

// 获得字符串字节长度
function getCharByte(str) {
    let char,
        cnCount = 0,
        enCount = 0,
        len = str.length;
    for(let i = 0; i < len; i++) {
        char = str.charAt(i);
        // eslint-disable-next-line no-control-regex
        if(/^[\u0000-\u00ff]$/.test(char)) { // 匹配双字节
            enCount += 1;
        } else {
            cnCount += 2;
        }
    }
    return {
        cn: cnCount,
        en: enCount
    };
}

// 获取字符串在屏幕的显示宽度
function getTxtWidth(str, fontSize) {
    if(str ==null || str == ''){
        return fontSize;
    }
    let obj = getCharByte(str);
    let cnBaseWidth = fontSize / 2;
    let enBaseWidth = fontSize * 0.57;
    return obj.cn * cnBaseWidth + obj.en * enBaseWidth;
}

// 跳转路由
function changeMenu (menuItem) {
    if(menuItem?.sub_navs?.length) {
        return;
    }
    emit('change-menu', menuItem.path);
}

function goLogin () {
    console.log('logout', 555)
    store.dispatch('logout');
}

function exit() {
   store.dispatch('logoutHome');
}

function goPage (name) {
    if(name === 'userHomePage' && !showPersonCenter.value) {
        return
    }
    pageJump({ name });
}

function goSelfUrl (str) {
    let url = getUrl(str);
    pageJump(url, '_blank');
}

const headerInputRef = ref(null);
const headerSearchRef = ref(null);

function mousedownChange (e) {
    let isInput = headerInputRef.value && headerInputRef.value.ref.contains(e.target) || ''; // 是否包含搜索输入框
    let isIcon = headerSearchRef.value && headerSearchRef.value.contains(e.target) || ''; // 是否包含搜索图标
    if(isInput || isIcon){
        return;
    }
    isSearch.value = false;
}

const pagePermission = computed(() => {
    return store.state?.pagePermission || {};
});

const comName = computed(() => {
    return pagePermission.value?.coopgroup?.moduleNameAlias || pagePermission.value?.coopgroup?.moduleName || '协作组';
});

const showManage = computed(() => { // 是否显示管理中心
    let pagePermission = store.state?.pagePermission || {};
    let isHaveIdmx = store.state.user?.isHaveIdmx;
    return !!pagePermission['manageCenter:base:home'] && isHaveIdmx;
})

const showPersonCenter = computed(() => { // 是否显示个人中心
    let pagePermission = store.state?.pagePermission || {};
    return !!pagePermission['personalCenter:page']
})

const showStrain = computed(() => { // 是否显示培训管理系统
    let pagePermission = store.state?.pagePermission || {};
    let isHaveStrain = store.state.user?.isHaveStrain;
    return !!pagePermission.continuingEducation && !!pagePermission.train && isHaveStrain;
})
const images = {
    'resourceApplication:my': require('@/assets/img/menu-icon/resource.png'), 
    'coopgroup:my': require('@/assets/img/menu-icon/group.png'), 
    'activity:my': require('@/assets/img/menu-icon/activity.png'), 
    'train:my': require('@/assets/img/menu-icon/course.png'), 
    'continuingEducation:my': require('@/assets/img/menu-icon/teach.png'), 
    'video:my': require('@/assets/img/menu-icon/case.png'),
    'moocApplication:my': require('@/assets/img/menu-icon/mooc.png'),
    'material:my': require('@/assets/img/menu-icon/material.png'),
    'workshop:my': require('@/assets/img/menu-icon/studio.png'),
    'competition:my': require('@/assets/img/menu-icon/competition.png'),
    'research:my': require('@/assets/img/menu-icon/research.png'),
    'selection:my': require('@/assets/img/menu-icon/competition.png'),
    'expertstudio:my': require('@/assets/img/menu-icon/studio2.png'),
    'basicschool:my': require('@/assets/img/menu-icon/school.png'),
    'project:my': require('@/assets/img/menu-icon/subject.png'),
    'resultcultivation:my': require('@/assets/img/menu-icon/achievement.png'),
};
const applications = ref([])
// 获取应用
function getApplicationList () {
    G_transmit('getUserCenterLatestBrand', {
       name: 'getUserCenterLatestBrand'
    }).then(res => {
        const data = res?.data || [];
        let menuList = [];
        let tempMap = {};
        data.length && data.forEach(item => {
            if (item.moduleKey && staticRoutes[item.moduleKey] && staticRoutes[item.moduleKey].name && !tempMap[item.moduleKey]) {
                tempMap[item.moduleKey] = item;
                let title = staticRoutes[item.moduleKey].title;
                let shortTitle = staticRoutes[item.moduleKey].meta?.shortTitle;
                if (item.moduleKey === 'coopgroup:my') {
                    title = comName.value;
                    shortTitle = comName.value;
                } else if (item.moduleKey === 'moocApplication:my') {
                    title = moocComName;
                    shortTitle = moocComName;
                }
                let temp = {
                    path: staticRoutes[item.moduleKey].path,
                    id: item.moduleKey,
                    title: title,
                    shortTitle: shortTitle,
                    route: { name: staticRoutes[item.moduleKey].name },
                    isOther: false,
                    icon: images[item.moduleKey]
                }
                menuList.push(temp);
            }
        })
        applications.value = menuList || []

    }).catch(() => {

    });
}


onMounted(() => {
     window.addEventListener('mousedown', mousedownChange, true); // 监听鼠标点击事件
})

onBeforeUnmount(() => {
    window.removeEventListener('mousedown', mousedownChange, true);
});

</script>
<style lang="scss">
// .main-drop-menu {
//     .el-dropdown-menu__item {
//         justify-content: center;
//     }
// }
</style>

<style lang="scss" scoped>

 // 主页导航主色
 $nav-main-color: var(--common-nav-main-color);
 // 主页导航选中主色1
 $common-nav-main-active-color1: var(--common-nav-main-active-color1);
 // 主页导航选中主色2
 $common-nav-main-active-color2: var(--common-nav-main-active-color2);
 // 主页更多下拉导航背景主色
 $nav-main-sub-bg-more-color:var(--nav-main-sub-bg-more-color);
 // 主页更多下拉导航文字主色
 $nav-main-sub-color: var(--common-nav-main-sub-color);
 // 主页更多下拉导航文字hover主色
 $nav-main-sub-hover-color: var(--common-nav-main-sub-hover-color);

 // 首页主色
 $home-main-color: var(--common-home-main-color);

.header-container {
    width: 100%;
    height: 60px;
    color: var(--main-text-color);
    background-color: #ffffff;
    position: fixed;
    z-index: 101;
    font-family: MicrosoftYaHei;
    .login-btn {
        width: 90px;
        height: 32px;
        background: $home-main-color;
        border-radius: 4px;
        display: inline-block;
        color: #ffffff;
        line-height: 32px;
        text-align: center;
        font-size: 14px;
    }
    .menu-list {
        height: 100%;
    }
    .left-wrap {
        position: relative;
        .logo {
            width: 26px;
            height: 26px;
        }
        .site-name {
            font-size: 16px;
            font-weight: bold;
            color: $nav-main-color;
            margin-left: 10px;
        }
        .little-site-name {
            font-size: 12px;
            line-height: 18px;
            text-align: center;
            word-break: break-all;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2; /* 这里是超出几行省略 */
            overflow: hidden;
        }
    }

    .menu-container {
        height: 60px;
        max-width: 650px;
        position: relative;
        margin-left: 50px;
        .menu-item {
            font-size: 14px;
            // margin-left: 40px;
            max-width: 228px;
            position: relative;
            height: 100%;
            margin-right: 36px;
            flex-shrink: 0;
            &:hover {
                .pop-menu-list {
                    display: block;
                }
                 // .menu-item-name {
                 //     color: $nav-main-sub-hover-color;
                 // }
                .menu-item-snv {
                    &::after {
                        content: '';
                        background: url(~@/assets/img/gateway/nav-open@2x.png) no-repeat;
                        width: 10px;
                        height: 10px;
                        background-size: contain;
                        margin-left: 4px;
                        display: inline-block;
                        position: absolute;
                        right: -16px;
                        top: calc(50% - 5px);
                        transform: rotate(180deg);
                    }
                }
            }
        }
        .mar-r40 {
            margin-right: 50px;
        }
        .menu-item-name {
            max-width: 140px;
            text-align: center;
            color: $nav-main-color;
            // word-break: break-all;
            // text-overflow: ellipsis;
            // display: -webkit-box;
            -webkit-box-orient: vertical;
            // -webkit-line-clamp: 2;
            // overflow: hidden;
            &:hover {
                font-weight: bold;
            }
        }
        .menu-item-snv {
            &::after {
                content: '';
                background: url(~@/assets/img/gateway/nav-open@2x.png) no-repeat;
                width: 10px;
                height: 10px;
                background-size: contain;
                margin-left: 4px;
                display: inline-block;
                position: absolute;
                right: -16px;
                top: 50%;
                transform: translateY(-50%);
            }
        }
        .active {
            font-weight: bold;
            &::after {
                content: '';
                position: absolute;
                bottom: 8px;
                width: 18px;
                margin: 0 auto;
                height: 3px;
                background: linear-gradient(332deg, $common-nav-main-active-color1, $common-nav-main-active-color2);
                border-radius: 2px;
                left: 50%;
                transform: translateX(-50%);
            }
        } 
        .submenu-list {
            // left: 80px;
            left: calc(50% + 7px);
            // left: 50%;
            padding: 16px 22px;
        }
    }
    .option-wrap {
        position: relative;
        height: 100%;
        display: flex;
        align-items: center;
        // margin-right: 36px;
        height: 60px;
        // display: flex;
        // align-items: center;
        &:hover {
            // margin-right: 50px;
            .more-menu-list {
                display: flex;
                white-space: nowrap;
            }
            .option-wrap-more {
                &::after {
                    content: '';
                    background: url(~@/assets/img/gateway/nav-open@2x.png) no-repeat;
                    width: 10px;
                    height: 10px;
                    background-size: contain;
                    margin-left: 4px;
                    display: inline-block;
                    transform: rotate(180deg);
                }
            }
        }
    }
    .option-wrap-more {
        font-size: 14px;
        color: var(--color-light-black);
        position: relative;
        cursor: pointer;

        &:hover {
           font-weight: bold;
        }
        &::after {
            content: '';
            background: url(~@/assets/img/gateway/nav-open@2x.png) no-repeat;
            width: 10px;
            height: 10px;
            background-size: contain;
            margin-left: 4px;
            display: inline-block;
        }
    } 

    .more-menu-list, .pop-menu-list {
        position: absolute;
        background: $nav-main-sub-bg-more-color;
        backdrop-filter: blur(10px);
        z-index: 3000;
        top: 49px;
        transition: display 0.2s;
        display: none;
        box-shadow: 0px 1px 6px 0px rgba(37,54,82,0.1);
        border-radius: 4px;

        &::before {
            content: '';
            position: absolute;
            left: 0;
            top: -2px;
            width: 100%;
            height: 2px;
            background: transparent;
            display: block;
        }
    }
    .more-menu-list {
        min-width: 152px;
        right: 0;
        padding: 10px 5px 0px;
    }
    .pop-menu-list {
        width: calc(100% + 16px);
        min-width: 130px;
        left: 50%;
        transform: translateX(-50%);
    }
    .pop-menu-item,
    .more-menu-item {
        color: $nav-main-sub-color;
        font-size: 14px;
        line-height: 21px;
        text-align: left;
        cursor: pointer;
        &:nth-child(n+2) {
            margin: 8px 0 0;
        }
        &:hover {
            color: $nav-main-sub-hover-color;
        }
    }
    .more-menu-item {
        margin: 10px 0 0;
    }
    .pop-menu-header {
        font-size: 15px;
        font-weight: bold;
        color: var(--nav-main-sub-color);
        line-height: 24px;
    }
    .right-wrap {
        display: flex;
        align-items: center;
        height: 100%;
    }
    .search-wrap {
        width: 280px;
        background: #f8f8f8;
        border-radius: 18px;
        :deep(.el-input__wrapper) {
            border-radius: 18px;
            background: #f8f8f8;
            box-shadow: none;
            padding: 2px 16px;
        }
    }

    .search-wrap-icon {
        width: 42px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        background: #F8F8F8;
        border-radius: 18px;
    }
    .suffix-icon {
        font-size: 18px;
        color: #000000;
        cursor: pointer;

        &:hover {
            color: $home-main-color;
        }
    }
    .news-img-wrap {
        position: relative;
        .iconfont {
            font-size: 22px;
            color: var(--srt-color-gray);
        }
        &:hover {
            .iconfont {
                color: $home-main-color;
            }
        }
        .news-num {
            position: absolute;
            font-size: 12px;
            min-width: 14px;
            height: 14px;
            line-height: 14px;
            text-align: center;
            padding: 0 3px;
            color: #FFFFFF;
            border-radius: 7px;
            background-color: #FF4719;
            left: 11px;
            bottom: 10px;
        }
    }
    .user-img {
        width: 36px;
        height: 36px;
        border-radius: 50%;
    }
    .user-name {
        margin-left: 6px;
        font-size: 14px;
        color: #000000;
    }
    .nav-item {
        display: flex;
        align-items: center;
        margin-left: 30px;
        &::after {
            content: '';
            background: url(~@/assets/img/gateway/user-open@2x.png) no-repeat;
            width: 10px;
            height: 10px;
            background-size: contain;
            margin-left: 6px;
            display: inline-block;
        }
        &:focus {
            outline: none;
        }
    }
    .middle-divider {
        height: 12px;
        background-color: var(--color-light-gray);
        margin: 1px 20px;
    }
    .mar-l40 {
        padding: 5px 15px 20px 15px;
    }

    .title-hover {
        &:hover {
            color: $nav-main-sub-hover-color
        }
    }
}
.header-shadow {
    box-shadow: 0px 4px 12px 0px rgba(37,54,82,0.08);
}
.tools-wrap {
    margin-left: 20px;
    height: 60px;
    display: flex;
    align-items: center;
    // margin-right: 36px;
    position: relative;
    cursor: pointer;
    .iconfont {
        font-size: 22px;
        &:hover {
            color: $home-main-color;
        }
    }
    .tools-title {
        display: flex;
        justify-content: flex-end;
        font-size: 14px;
        line-height: 14px;
        color: var(--color-light-black);
        min-width: 60px;
        text-align: center;
        // word-break: break-all;
        // text-overflow: ellipsis;
        // display: -webkit-box;
        // -webkit-box-orient: vertical;
        // -webkit-line-clamp: 2;
        // overflow: hidden;
        &:hover {
            font-weight: bold;
        }
        &::after {
            content: '';
            background: url(~@/assets/img/gateway/nav-open@2x.png) no-repeat;
            width: 10px;
            height: 10px;
            background-size: contain;
            margin-left: 4px;
            display: inline-block;
            position: absolute;
            right: -16px;
            top: 50%;
            transform: translateY(-50%);
        }
    }
    &:hover {
        .pop-menu-list {
            display: block;
        }
        .tools-title {
            &::after {
                content: '';
                background: url(~@/assets/img/gateway/nav-open@2x.png) no-repeat;
                width: 10px;
                height: 10px;
                background-size: contain;
                margin-left: 4px;
                display: inline-block;
                transform: rotate(180deg);
                display: inline-block;
                position: absolute;
                right: -16px;
                top: calc(50% - 5px);
            }
        }
    }
    .submenu-list {
        padding: 16px 22px;
    }
}
.user-avatar-select-wrap {
    padding: 16px 22px;
    font-size: 14px;
    line-height: 14px;
    font-family: MicrosoftYaHei;
    .user-option-item {
        text-align: center;
        // margin-bottom: 20px;
        margin: 0 0 20px;
        padding: 0;
        cursor: pointer;
        width: 56px;
        text-align: center;
        &:hover {
            color: $home-main-color;
        }
    }
    .w88 {
        width: 88px;
    }
    .user-option-item:last-child {
        margin-bottom: 0;
    }
}
</style>
   